import { render, staticRenderFns } from "./unfinishProject.vue?vue&type=template&id=2384b6e4&scoped=true&"
import script from "./unfinishProject.vue?vue&type=script&lang=js&"
export * from "./unfinishProject.vue?vue&type=script&lang=js&"
import style0 from "./unfinishProject.vue?vue&type=style&index=0&id=2384b6e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384b6e4",
  null
  
)

export default component.exports